import {
  getConfigFields,
  getEmptyFieldRule,
  getMaxLengthConstraint,
  getNotNullConstraint,
  getRemoteFieldRule
} from '../fields.js'
import {formFieldIds} from '../values.js'

const {makeId, modelId, fuelId, yearId, versionId, kilometersId, plate} = formFieldIds

const formC2bVehicleFieldsConfig = [
  getConfigFields[plate]({customProps: {help: 'COMMON.FORM_FIELDS.PLATE.MOTOS.HELP'}}),
  getConfigFields[makeId](),
  getConfigFields[fuelId]({customProps: {label: 'COMMON.FUEL_TYPE'}}),
  getConfigFields[yearId](),
  getConfigFields[modelId](),
  getConfigFields[versionId](),
  getConfigFields[kilometersId]({
    customProps: {
      constraints: [
        getNotNullConstraint({
          message: 'COMMON.FORM_FIELDS.KMS.MOTOS.CONSTRAINTS.NOTNULL'
        }),
        getMaxLengthConstraint({
          value: 7
        })
      ]
    }
  })
]

const formC2bVehicleFieldsWithRemotePropertyOrder = [makeId, fuelId, yearId, modelId, versionId]

const getFormC2bVehicleRules = () => {
  const rules = {}

  formC2bVehicleFieldsWithRemotePropertyOrder.forEach((fieldId, fieldIdIndex) => {
    if (!fieldIdIndex) return
    const previousFields = formC2bVehicleFieldsWithRemotePropertyOrder.slice(0, fieldIdIndex)
    const fieldRules = previousFields.map((previousFieldId, previousFieldIdIndex) => {
      return previousFieldIdIndex === previousFields.length - 1
        ? getRemoteFieldRule({id: previousFieldId})
        : getEmptyFieldRule({id: previousFieldId})
    })
    rules[fieldId] = fieldRules
  })

  return rules
}

const formC2bVehicleInitialValues = {
  [plate]: '',
  [makeId]: '',
  [fuelId]: '',
  [yearId]: '',
  [modelId]: '',
  [versionId]: '',
  [kilometersId]: ''
}

export const formC2bVehicleFormConfig = {
  fields: formC2bVehicleFieldsConfig,
  initialValues: formC2bVehicleInitialValues,
  remotes: formC2bVehicleFieldsWithRemotePropertyOrder,
  rules: getFormC2bVehicleRules()
}
